import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import api from 'mastodon/api';

import { IconButton } from 'mastodon/components/icon_button';
import { SunIcon } from 'mastodon/components/icons/sun';
import { MoonIcon } from 'mastodon/components/icons/moon';
import { SystemIcon } from 'mastodon/components/icons/system';

import { showAlert } from 'mastodon/actions/alerts';
import { useAppDispatch } from 'mastodon/store';

import { CloseIcon } from 'mastodon/components/icons/close';

const messages = {
  title: { id: 'theme.title', defaultMessage: 'Choose theme' },
  description: { id: 'theme.description', defaultMessage: 'Choose your theme to enhance accessibility' },
  close: { id: 'bundle_modal_error.close', defaultMessage: 'Close' },
  light: { id: 'theme.light', defaultMessage: 'Light' },
  dark: { id: 'theme.dark', defaultMessage: 'Dark' },
  system: { id: 'theme.system', defaultMessage: 'System' },
};

const ThemeModal = ({ onClose, currentTheme }) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();

  const handleThemeChange = (newTheme) => {
    api()
      .put('/api/v1/preferences', { theme: newTheme })
      .then(() => {
        dispatch(showAlert({ message: intl.formatMessage({ id: 'theme.change_success', defaultMessage: 'Theme changed successfully' }) }));
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error updating locale:', error);
        dispatch(showAlert({ message: intl.formatMessage({ id: 'theme.change_error', defaultMessage: 'Failed to update theme' }) }));
      });
  };

  const themes = [
    { code: 'mastodon-light', label: messages.light, icon: SunIcon },
    { code: 'default', label: messages.dark, icon: MoonIcon },
    // { code: 'theme-system', label: messages.system, icon: SystemIcon },
  ];

  return (
    <div className={classNames('modal-root__modal', 'theme-modal')}>
      <div className='theme-modal-container'>
        <div className='theme-modal__header'>
          <h3>{intl.formatMessage(messages.title)}</h3>
          <IconButton
            className='theme-modal__close'
            title={intl.formatMessage(messages.close)}
            icon='close'
            iconComponent={CloseIcon}
            onClick={onClose}
            size={20}
          />
        </div>
        <div className='theme-modal__content'>
            {themes.map(({ code, label, icon: Icon }) => (
              <div
                key={code}
                className={classNames('theme-modal__item', { active: currentTheme === code })}
                onClick={() => handleThemeChange(code)}
                role='button'
                tabIndex={0}
                onKeyPress={(e) => e.key === 'Enter' && handleThemeChange(code)}
              >
                <Icon />
                <p>{intl.formatMessage(label)}</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

ThemeModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  currentTheme: PropTypes.string.isRequired,
};

export default ThemeModal;